import { WEBINARS } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useWebinars(): boolean {
  return useIsFeatureEnabled(WEBINARS);
}
